import { HTTP, BACKEND_API_URL } from "@/utils/http-common"

export default {
  async getStats(filters = {}) {
    const path = `/activity/fidelity/stats`
    const queryParams = new URLSearchParams(filters).toString()
    const url = queryParams ? `${path}?${queryParams}` : path
    return (await HTTP.get(url)).data
  },

  async markInactiveFollowup(payload) {
    const { data } = await HTTP.post("/activity/fidelity/inactive-followup", payload)
    return data
  },

  async getInactiveFollowupCauses() {
    const { data } = await HTTP.get("/activity/fidelity/inactive-followup/causes")
    return data?.results || []
  },

  exportReport(filters = {}, $) {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams(filters).toString()
      const url = `${BACKEND_API_URL}/activity/fidelity/stats/export${params ? '?' + params : ''}`

      const xhr = new XMLHttpRequest()
      xhr.open("GET", url, true)

      const user = $.$store.state.app.user
      if (user && user.key) {
        xhr.setRequestHeader("authorization", "Token " + user.key)
      }
      if (user && user.tzName) {
        xhr.setRequestHeader("X-Timezone-Name", user.tzName)
      }

      xhr.responseType = "blob"

      xhr.onload = function () {
        if (xhr.status === 200) {
          resolve(xhr.response)
        } else {
          reject(xhr)
        }
      }

      xhr.onerror = function () {
        reject(xhr)
      }

      xhr.send()
    })
  }
}
